
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.06 4c4.437 0 8.04 3.585 8.04 8s-3.603 8-8.04 8c-4.437 0-8.04-3.585-8.04-8s3.603-8 8.04-8zm0 .667c4.068 0 7.37 3.286 7.37 7.333 0 4.047-3.302 7.333-7.37 7.333S4.69 16.047 4.69 12c0-4.047 3.302-7.333 7.37-7.333zm0 7.333h4.02v.667h-4.69v-6h.67V12z","fill":"#fff"}})])
          )
        }
      }
    